import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificacionGestionService } from '../../../../services/gestion-referidos/gestion-referidos.service';
import { NotificacionGestion } from '../../../../models/gestion-referidos.model';
import { TrackData } from '../../../../models/app-track/track-data.model';
import { AuthService } from '../../../../services/security/auth.service';

@Component({
  selector: 'app-gestion-referidos',
  templateUrl: './gestion-referidos.component.html',
  styleUrls: ['./gestion-referidos.component.css'],
})
export class GestionReferidosComponent {
  siSeleccionado: boolean | null = null;
  observaciones: string = '';
  logInfo: any;
  cedula_Asesor: string = '';
  nombre_Asesor: string = '';
  trackData: any;

  constructor(
    public dialogRef: MatDialogRef<GestionReferidosComponent>,
    private notificacionGestion: NotificacionGestionService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('data recibida en dialog:', data);
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    const userCC = this.logInfo?.document;
    this.cedula_Asesor = userCC.split('.')[1].trim();

    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
    this.nombre_Asesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';

    this.trackData = {
      module: 'Campana de notificaciones',
      category: 'N/A',
      submodule: '¡Tienes XX usuarios que ya cumplieron 2 meses desde que inició su servicio! Haz clic aquí para ver quiénes son y contactarlos',
      functionality: 'Guardar',
      cedulaAsesor: this.cedula_Asesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombre_Asesor,
      identificadorInteraccion: 'REF_GESTION_REF_GUARDAR'
    };
  }

  guardar() {

    if (this.siSeleccionado === null) {
      console.warn('Debe seleccionar SI o NO');
      return;
    }
    
    const referidos = this.siSeleccionado ? 'SI' : 'NO';
    const idUsuario = this.data.idUsuario;

    const esPrimeraVez = !this.data.usuariosNoMarcados[idUsuario];

    // Determinar el contador
    let nuevoContador: number;
    let eliminarUsuario: boolean;

    if (referidos === 'SI') {
      // SI → contador = 1, se elimina
      nuevoContador = 1;
      eliminarUsuario = true;
    } else {
      // NO
      if (esPrimeraVez) {
        // Primera vez NO → contador = 1, NO se elimina
        nuevoContador = 1;
        eliminarUsuario = false;
      } else {
        // Segunda vez NO → contador = 2, SÍ se elimina
        nuevoContador = 2;
        eliminarUsuario = true;
      }
    }

    this.data.usuariosNoMarcados[idUsuario] = nuevoContador;

    const gestion: NotificacionGestion = {
      idDetalle: this.data.idDetalle,
      observaciones: this.observaciones.trim(),
      referidos,
      contador: nuevoContador,
      fechaGestion: new Date().toISOString(),
    };

    this.notificacionGestion.guardar(gestion).subscribe({
      next: (res) => {
        console.log(
          `Usuario ${idUsuario}: ${referidos}, Contador: ${nuevoContador}, Eliminar: ${eliminarUsuario}`
        );

        this.dialogRef.close({
          idUsuario,
          contador: nuevoContador,
          referidos,
          observaciones: this.observaciones,
          estado: !eliminarUsuario,
          eliminarUsuario,
          idNotificacion: this.data.idNotificacion,
        });
      },
      error: (err) => console.error('Error guardando gestión:', err),
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
  
}
